(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-materials-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductMaterialsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-materials-viewport]');
      this.cards = Array.from(this.querySelectorAll('[data-material-card]'));
      this.activeIndex = Number(this.dataset.initialActiveIndex || Math.floor(this.cards.length / 2));
      this.scrollFrame = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.hasDragged = false;
      this.suppressOpen = false;

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));

      if (this.viewport) {
        this.viewport.addEventListener('scroll', this.scheduleActiveUpdate.bind(this), { passive: true });
        this.viewport.addEventListener('pointerdown', this.handlePointerDown.bind(this), { passive: true });
        this.viewport.addEventListener('pointermove', this.handlePointerMove.bind(this), { passive: true });
        this.viewport.addEventListener('pointerup', this.handlePointerEnd.bind(this), { passive: true });
        this.viewport.addEventListener('pointercancel', this.handlePointerEnd.bind(this), { passive: true });
      }

      requestAnimationFrame(() => {
        this.setActiveIndex(this.activeIndex);
        this.centerActiveCard(false);
        this.updateActiveCard();

        requestAnimationFrame(() => {
          this.setActiveIndex(this.activeIndex);
          this.centerActiveCard(false);
          this.updateActiveCard();
        });
      });

      window.setTimeout(() => {
        this.setActiveIndex(this.activeIndex);
        this.centerActiveCard(false);
        this.updateActiveCard();
      }, 250);
    }

    handleClick(event) {
      const previous = event.target.closest('[data-material-prev]');
      const next = event.target.closest('[data-material-next]');
      const opener = event.target.closest('[data-material-open]');
      const close = event.target.closest('[data-material-close]');
      const dialog = event.target.closest('[data-material-dialog]');

      if (previous && this.contains(previous)) {
        event.preventDefault();
        this.scrollToIndex(this.activeIndex - 1);
        return;
      }

      if (next && this.contains(next)) {
        event.preventDefault();
        this.scrollToIndex(this.activeIndex + 1);
        return;
      }

      if (close && this.contains(close)) {
        event.preventDefault();
        close.closest('dialog')?.close();
        return;
      }

      if (dialog && event.target === dialog) {
        dialog.close();
        return;
      }

      if (opener && this.contains(opener)) {
        if (this.suppressOpen) {
          event.preventDefault();
          this.suppressOpen = false;
          return;
        }

        const card = opener.closest('[data-material-card]');
        const materialDialog = card?.querySelector('[data-material-dialog]');

        if (!materialDialog) return;

        event.preventDefault();
        this.scrollToIndex(this.cards.indexOf(card));

        if (typeof materialDialog.showModal === 'function') {
          materialDialog.showModal();
        } else {
          materialDialog.setAttribute('open', '');
        }
      }
    }

    handlePointerDown(event) {
      if (!event.isPrimary) return;

      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.hasDragged = false;
    }

    handlePointerMove(event) {
      if (!event.isPrimary) return;

      const distanceX = Math.abs(event.clientX - this.pointerStartX);
      const distanceY = Math.abs(event.clientY - this.pointerStartY);

      if (distanceX > 8 || distanceY > 8) {
        this.hasDragged = true;
      }
    }

    handlePointerEnd(event) {
      if (!event.isPrimary) return;

      this.suppressOpen = this.hasDragged;

      if (this.suppressOpen) {
        setTimeout(() => {
          this.suppressOpen = false;
        }, 120);
      }
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        this.scrollToIndex(this.activeIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        this.scrollToIndex(this.activeIndex + 1);
      }
    }

    scheduleActiveUpdate() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateActiveCard();
      });
    }

    updateActiveCard() {
      if (!this.viewport || this.cards.length === 0) return;

      const viewportRect = this.viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(viewportCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.setActiveIndex(closestIndex);
    }

    scrollToIndex(index, smooth = true) {
      if (!this.viewport || this.cards.length === 0) return;

      const targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));
      this.setActiveIndex(targetIndex);
      this.centerActiveCard(smooth);
    }

    setActiveIndex(index) {
      const targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));

      this.activeIndex = targetIndex;

      this.cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === targetIndex);
      });
    }

    centerActiveCard(smooth = true) {
      if (!this.viewport || this.cards.length === 0) return;

      const targetCard = this.cards[this.activeIndex];
      const viewportRect = this.viewport.getBoundingClientRect();
      const cardRect = targetCard.getBoundingClientRect();
      const left = this.viewport.scrollLeft + cardRect.left + cardRect.width / 2 - viewportRect.left - viewportRect.width / 2;

      this.viewport.scrollTo({
        left,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }
  }

  if (!customElements.get('product-materials-carousel')) {
    customElements.define('product-materials-carousel', ProductMaterialsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
  class ProductVideoGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));

      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('pause', () => this.handlePause(video));
        video.addEventListener('ended', () => this.handleEnded(video));
      });
    }

    handleClick(event) {
      const toggle = event.target.closest('[data-product-video-toggle]');

      if (!toggle || !this.contains(toggle)) return;

      const card = toggle.closest('[data-product-video-card]');
      const video = card?.querySelector('video');

      if (!card || !video) return;

      event.preventDefault();
      this.pauseOtherVideos(video);

      video.setAttribute('controls', 'controls');

      const playPromise = video.play();
      card.classList.add('is-playing');

      if (playPromise?.catch) {
        playPromise.catch(() => {
          card.classList.remove('is-playing');
          video.removeAttribute('controls');
        });
      }
    }

    pauseOtherVideos(activeVideo) {
      this.querySelectorAll('video').forEach((video) => {
        if (video === activeVideo) return;

        const card = video.closest('[data-product-video-card]');
        video.pause();
        video.removeAttribute('controls');
        card?.classList.remove('is-playing');
      });
    }

    handlePause(video) {
      const card = video.closest('[data-product-video-card]');
      card?.classList.remove('is-playing');
      video.removeAttribute('controls');
    }

    handleEnded(video) {
      const card = video.closest('[data-product-video-card]');
      card?.classList.remove('is-playing');
      video.removeAttribute('controls');
      video.currentTime = 0;
    }
  }

  if (!customElements.get('product-video-gallery')) {
    customElements.define('product-video-gallery', ProductVideoGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
